import React from 'react';
import { NodeType } from '../../types';
import { NodeCardProps } from './NodeCardProps';
import { GenericNodeCard } from './GenericNodeCard';
import { AcNodeCard } from './AcNodeCard';
import { ShutterNodeCard } from './ShutterNodeCard';
import { LightNodeCard } from './LightNodeCard';
import { BoilerNodeCard } from './BoilerNodeCard';
import { FanNodeCard } from './FanNodeCard';
import { SmartPlugNodeCard } from './SmartPlugNodeCard';
import { VacuumNodeCard } from './VacuumNodeCard';
import { TvNodeCard } from './TvNodeCard';

export const getNodeCardComponent = (type?: NodeType): React.FC<NodeCardProps> => {
  switch (type) {
    case 'air_conditioner': return AcNodeCard;
    case 'shutter':         return ShutterNodeCard;
    case 'light':           return LightNodeCard;
    case 'boiler':          return BoilerNodeCard;
    case 'fan':             return FanNodeCard;
    case 'smart_plug':      return SmartPlugNodeCard;
    case 'vacuum':          return VacuumNodeCard;
    case 'tv':              return TvNodeCard;
    default:                return GenericNodeCard;
  }
};

export type { NodeCardProps };
